import script from "./review.vue?vue&type=script&setup=true&lang=js"
export * from "./review.vue?vue&type=script&setup=true&lang=js"

import "./review.vue?vue&type=style&index=0&id=30ae4651&lang=css"

const __exports__ = script;

export default __exports__